// src/components/TokenGrid.js
import React from 'react';
import Token from './Token';

function TokenGrid({ data, onTokenClick, isCaregiverScreen }) {
  return (
    <div className="grid-container">
      {data.map((token, index) => (
        <Token
          key={index}
          data={token}
          onClick={(event) => onTokenClick(index, event)} // already correct
          isCaregiverScreen={isCaregiverScreen}
        />
      ))}
    </div>
  );
}

export default TokenGrid; 